/**
 * Utility functions for managing caret position in contenteditable elements
 */

/**
 * Get the current caret position within an element
 * @param {HTMLElement} element - The contenteditable element
 * @returns {number} The caret offset position
 */
export function getCaretPosition(element) {
  let caretOffset = 0;
  const selection = window.getSelection();

  if (selection.rangeCount > 0) {
    const range = selection.getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(element);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    caretOffset = preCaretRange.toString().length;
  }

  return caretOffset;
}

/**
 * Set the caret position within an element
 * @param {HTMLElement} element - The contenteditable element
 * @param {number} offset - The desired caret position
 */
export function setCaretPosition(element, offset) {
  const range = document.createRange();
  const selection = window.getSelection();

  let charCount = 0;
  let found = false;

  const traverseNodes = (node) => {
    if (found) return;

    if (node.nodeType === Node.TEXT_NODE) {
      const nextCharCount = charCount + node.length;
      if (offset <= nextCharCount) {
        range.setStart(node, offset - charCount);
        range.collapse(true);
        found = true;
        return;
      }
      charCount = nextCharCount;
    } else {
      for (let i = 0; i < node.childNodes.length; i++) {
        traverseNodes(node.childNodes[i]);
        if (found) return;
      }
    }
  };

  traverseNodes(element);

  if (found) {
    selection.removeAllRanges();
    selection.addRange(range);
  }
}

/**
 * Escape HTML to prevent XSS attacks
 * @param {string} text - The text to escape
 * @returns {string} The escaped HTML
 */
export function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
